define('model/search/search',['../selector'], function(selector) {
    'use strict';
    return function(json) {
        return selector(json, 'results', 'address, dist, position, score, poi, type, addressRanges, boundingBox');
    };
});

